import { ReactElement } from 'react';

import { Alert } from 'reactstrap';

import { useRemainingTokenTime } from '@hsp/react-hooks';
import { isDev } from '@hsp/utilities';

export const useTokenTime = () => {
  const { color, remaining } = useRemainingTokenTime();
  let Component: ReactElement | null = null;

  if (isDev) {
    Component = (
      <div className="align-items-center d-flex ms-3 small">
        <span className="me-1 font-weight-semibold">Token:</span>
        <Alert
          className="align-items-center d-flex justify-content-center mb-0 p-0"
          color={color}
          style={{ width: '45px' }}>
          {remaining}
        </Alert>
      </div>
    );
  }

  return Component;
};
